export const lowerQuality=[
	{
		name: "last_resort",
		title: "Last Resort   --Eagles",
	 	// link: "https://drive.google.com/uc?export=download&id=17tGAeWjScDHPPIx2FWBqolzQaqvneCTB",
	 	link : 'https://od.lk/s/OF8xODc2NDQ3NTBf/240p%20Eagles%20-%20The%20Last%20Resort%20-%20%28Paradise%29%20-%20The%20Last%20Resort%20lyrics%20on%20screen%20%26%20description.mp4'
	},

	{
		name : 'bohemian_rhapsody',
		title : "Bohemian Rhapsody   --Queen",
		link : 'https://od.lk/s/OF8xODc2NDU5Njlf/Queen%20Bohemian%20Rhapsody%20Official%20Video%20Remastered_v240P.mp4'
	}
]	